export const RETENTION_OPTIONS = [
  {
    value: null,
    label: 'Unlimited',
    requiresSubscription: true,
    hint: 'Available on Pro plan — items will be stored indefinitely.',
  },
  { value: 7776000, label: '90 days' },
  { value: 2592000, label: '30 days' },
  { value: 604800,  label: '7 days' },
  { value: 86400,   label: '1 day' },
  { value: 3600,    label: '1 hour' },
];

export const DEFAULT_RETENTION = 7776000; // 90 days

export function retentionLabel(seconds) {
  if (seconds == null) return 'Unlimited';
  const opt = RETENTION_OPTIONS.find(o => o.value === seconds);
  return opt ? opt.label : `${seconds}s`;
}

export function retentionBadge(seconds) {
  if (seconds == null) return null;
  const map = { 7776000: '90d', 2592000: '30d', 604800: '7d', 86400: '1d', 3600: '1h' };
  return map[seconds] ?? null;
}
